(function (window, document, undefined) {

  window.vendors = {

    search: (t) => {
      let text =  decodeURI(t).toLowerCase().replace('&', '&amp;'),
          items = document.querySelectorAll('.lbox__content li > a');

      if (t.length == 0) {
        let s = document.querySelector('.s_vendors [name="vendor_name"]');
        if (s) {
          s.value = '';
        }
      } 

      if (items.length) {
        [].forEach.call(items, function(e) {
          let e_value = e.innerHTML.toLowerCase(),
              li = e.closest('li');

          if (text.length == 0) {
            li.classList.remove('is_active');
          } else {
            if ( e_value.includes(text)) {
              li.classList.add('is_active');
            } else {
              li.classList.remove('is_active');
            }
          }

          let p = e.closest('ul'),
              p_li = p.querySelectorAll('li.is_active');

          if (text.length == 0) {
            p.closest('.lbox').classList.remove('lbox--hide');
          } else {
            if (p_li.length) {
              p.closest('.lbox').classList.remove('lbox--hide');
            } else {
              p.closest('.lbox').classList.add('lbox--hide');
            }
          }

        });
      }
    },

    init: () => {
      const e_input = document.querySelector('.s_vendors .xfield--search .xfield__input'),
            alphabet_chars = document.querySelectorAll('.s_vendors__alphabet [data-char]');

      function removeNavSelectedClass () {
        let nav_selected_items = document.querySelectorAll('.s_vendors__alphabet .is_selected');
        if (nav_selected_items.length) {
          [].forEach.call(nav_selected_items, function(g) {
            g.classList.remove('is_selected');
          });
        }
      }
      
      function removeContentSelectedClass () {
        let content_selected_items = document.querySelectorAll('.s_vendors .lbox.is_selected');
        if (content_selected_items.length) {
          [].forEach.call(content_selected_items, function(g) {
            g.classList.remove('is_selected');
          });
        }
      }

      if (e_input) {
        e_input.addEventListener('click', (f) => {
          window.vendors.search(f.target.value);
        });

        e_input.addEventListener('focus', (f) => {
          window.vendors.search(f.target.value);
        });

        e_input.addEventListener('keyup', (f) => {
          window.vendors.search(f.target.value);
          removeNavSelectedClass();
          removeContentSelectedClass();
          f.target.closest('.s_vendors').setAttribute('data-char','');
          f.target.closest('.s_vendors').classList.remove('is_selected');
        });

        e_input.addEventListener('paste', (f) => {
          window.vendors.search(f.target.value);
          removeNavSelectedClass();
          removeContentSelectedClass();
          f.target.closest('.s_vendors').setAttribute('data-char','');
          f.target.closest('.s_vendors').classList.remove('is_selected');
        });

        e_input.addEventListener('blur', (f) => {
          window.vendors.search(f.target.value);
        });
      }

      if (alphabet_chars.length) {
        [].forEach.call(alphabet_chars, function(e) {
          e.addEventListener('click', () => {
            
            let data_items_number = parseFloat(e.getAttribute('data-items-number')),
                s_vendors = e.closest('.s_vendors');
                s_vendors_char = s_vendors.hasAttribute('data-char') ? s_vendors.getAttribute('data-char') : false,
                char = e.getAttribute('data-char');
                
            if (data_items_number != 0) {
              if (s_vendors_char == char) {
                removeNavSelectedClass();
                removeContentSelectedClass();
                s_vendors.setAttribute('data-char','');
                document.querySelector('.s_vendors').classList.remove('is_selected');
              } else {
                removeNavSelectedClass();
                removeContentSelectedClass();
                s_vendors.setAttribute('data-char',char);
                document.querySelector('.s_vendors').classList.add('is_selected');
                document.querySelector('.s_vendors .s_vendors__alphabet [data-char="'+char+'"]').classList.add('is_selected');
                document.querySelector('.s_vendors .lbox[data-char="'+char+'"]').classList.add('is_selected');
              }
              window.vendors.search('');
            } else {
              removeNavSelectedClass();
              removeContentSelectedClass();
              s_vendors.setAttribute('data-char','');
              document.querySelector('.s_vendors').classList.remove('is_selected');
            }
            
          });
        });
      }
    }

  };

  window.vendors.init();

})(window, window.document);
